import React from "react";

class PostAnimation extends React.Component{
    render(){

        return(
            <div className="layout-settings">
                PostAnimation
                <button onClick={()=>this.props.activeSetting(0)} type="button" className="btn btn-secondary me-4">Back</button>
            </div>
        )
    }
}

export default PostAnimation;